module.exports = __webpack_public_path__ + "static/media/label-energie-carbone.95c68666.jpg";